"use client";

import type { ReactNode } from "react";

/** Светлая тема зафиксирована; без next-themes — избегаем <script> в дереве (React 19 / Next 16). */
export function ThemeProvider({ children }: { children: ReactNode }) {
  return <>{children}</>;
}
